var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconResponders01 = function SvgIconResponders01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_responders-01_svg2__a",
    x1: 17.64,
    x2: 82.29,
    y1: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_responders-01_svg2__a",
    id: "icon_responders-01_svg2__b",
    x1: 29.39,
    x2: 43.31,
    y1: 36.28,
    y2: 36.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_responders-01_svg2__a",
    id: "icon_responders-01_svg2__c",
    x1: 29.6,
    x2: 60.74,
    y1: 55.87,
    y2: 55.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_responders-01_svg2__a",
    id: "icon_responders-01_svg2__d",
    x1: 29.39,
    x2: 60.74,
    y1: 46.08,
    y2: 46.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_responders-01_svg2__a",
    id: "icon_responders-01_svg2__e",
    x1: 0,
    x2: 78.66,
    y1: 63.21,
    y2: 63.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_responders-01_svg2__a",
    id: "icon_responders-01_svg2__f",
    x1: 19.26,
    x2: 100,
    y1: 37.75,
    y2: 37.75
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M74.45 24.53H25.48c-4.32 0-7.84 3.52-7.84 7.84V59.8c0 4.32 3.52 7.84 7.84 7.84h3.47l-2.55 4.98c-.39.76-.24 1.68.36 2.28s1.53.74 2.28.36l14.78-7.6h30.64c4.32 0 7.84-3.52 7.84-7.84V32.37c0-4.32-3.52-7.84-7.84-7.84Zm3.92 35.28c0 2.16-1.76 3.92-3.92 3.92H43.34c-.31 0-.62.07-.9.22l-9.79 5.03 1.24-2.42c.67-1.3-.28-2.85-1.74-2.85h-6.67c-2.16 0-3.92-1.76-3.92-3.92V32.36c0-2.16 1.76-3.92 3.92-3.92h48.98c2.16 0 3.92 1.76 3.92 3.92v27.45Z",
    style: {
      fill: "url(#icon_responders-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.35 38.24h10c1.08 0 1.96-.88 1.96-1.96s-.88-1.96-1.96-1.96h-10c-1.08 0-1.96.88-1.96 1.96s.88 1.96 1.96 1.96",
    style: {
      fill: "url(#icon_responders-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.78 53.91H31.56c-1.08 0-1.96.88-1.96 1.96s.88 1.96 1.96 1.96h27.22c1.08 0 1.96-.88 1.96-1.96s-.88-1.96-1.96-1.96",
    style: {
      fill: "url(#icon_responders-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.78 44.12H31.35c-1.08 0-1.96.88-1.96 1.96s.88 1.96 1.96 1.96h27.43c1.08 0 1.96-.88 1.96-1.96s-.88-1.96-1.96-1.96",
    style: {
      fill: "url(#icon_responders-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.54 88.13-6.01-3.57c-.93-.55-2.13-.25-2.69.68-.55.93-.25 2.13.68 2.69l3.36 2c-6.96 4-14.82 6.11-22.93 6.11C24.57 96.04 3.91 75.39 3.91 50c0-7.28 1.65-14.24 4.9-20.69.49-.97.1-2.14-.87-2.63s-2.14-.1-2.63.87C-4.08 46.19-1.1 69.6 14.62 85.33c16.03 16.03 40.06 18.82 58.87 8.74l-.95 3.4a1.962 1.962 0 0 0 3.78 1.06l2.25-8.08c.26-.94-.21-1.89-1.05-2.31Z",
    style: {
      fill: "url(#icon_responders-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.96.04c-9.23 0-18.07 2.48-25.85 7.2l.99-4.85c.22-1.06-.47-2.09-1.53-2.31s-2.09.47-2.31 1.53l-1.96 9.6c-.17.85.24 1.72 1.01 2.13l7.84 4.11c.96.5 2.14.14 2.65-.82.5-.96.13-2.14-.82-2.65l-5.02-2.64c7.45-4.84 16.03-7.38 25.01-7.38 25.38 0 46.04 20.65 46.04 46.04 0 7.91-2.04 15.7-5.89 22.55-.53.94-.2 2.14.75 2.67.94.53 2.14.2 2.67-.75C112.28 41.16 88.03.04 49.96.04",
    style: {
      fill: "url(#icon_responders-01_svg2__f)"
    }
  }));
};
export default SvgIconResponders01;